package app.bloomey.web.core.offCanvas.items

import androidx.compose.runtime.*
import app.bloomey.web.components.widgets.*
import app.bloomey.web.core.data.UiState
import app.bloomey.web.core.data.models.Category
import app.bloomey.web.core.offCanvas.LocalOffCanvasController
import app.bloomey.web.core.offCanvas.OffCanvasItem
import app.bloomey.web.core.res.Res
import app.bloomey.web.core.res.icClose
import app.bloomey.web.modules.library.LibraryContract
import app.bloomey.web.modules.library.LibraryViewModel
import app.bloomey.web.theme.SpanTextHeader1Variant
import app.bloomey.web.theme.toSitePalette
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.AlignSelf
import org.jetbrains.compose.web.css.px

data class LibraryVideosOffCanvasItem(val id: String, val library: Category? = null) : OffCanvasItem {
    override val pathId: String
        get() = "library:$id"

    @Composable
    override fun Content(modifier: Modifier) {
        val sitePalette = ColorMode.current.toSitePalette()
        val offCanvasController = LocalOffCanvasController.current
        val scope = rememberCoroutineScope()
        val viewModel = remember { LibraryViewModel(scope) }
        val uiState by viewModel.observeStates().collectAsState()
        val pageState = uiState.detailVideos
        val pageSize = 20
        val getPage = { page: Int ->
            viewModel.trySend(LibraryContract.Inputs.GetLibraryVideos(id, page = page, size = pageSize))
        }
        LaunchedEffect(Unit) {
            getPage(1)
        }

        Column(
            modifier = modifier
                .padding(40.px)
                .background(sitePalette.background)
        ) {
            Row(modifier = Modifier.fillMaxWidth()) {
                SvgLoader(
                    Res.Assets.icClose,
                    modifier = Modifier.size(24.px)
                        .cursor(Cursor.Pointer)
                        .onClick {
                            offCanvasController.pop()
                        },
                    color = sitePalette.onBackgroundLight
                )
                Spacer()
            }
            Height(20.px)
            library?.let { SpanText(it.title, variant = SpanTextHeader1Variant) }
            Height(4.px)
            SpanText("#$id")
            Height(40.px)
            when (pageState) {
                is UiState.Error -> SiteErrorView(text = pageState.errorMessage) {
                    getPage(uiState.detailsPage)
                }

                UiState.Initial -> {}
                UiState.Loading -> LoadingView()
                is UiState.Success -> {
                    SimpleGrid(
                        numColumns = numColumns(base = 1, 2, 2),
                        modifier = Modifier
                            .fillMaxWidth()
                            .weight(1)
                            .margin(bottom = 30.px)
                            .columnGap(16.px)
                            .rowGap(16.px)
                    ) {
                        pageState.data.items.forEach {
                            VideoItem(item = it) { video ->
                                offCanvasController.push(VideoOffCanvasItem(video.id, video = video) {
                                    getPage(1)
                                })
                            }
                        }
                    }
                    PaginationController(
                        modifier = Modifier.alignSelf(AlignSelf.End),
                        pageCount = pageState.data.totalPages,
                        currentPage = uiState.detailsPage
                    ) {
                        getPage(it)
                    }
                }
            }
        }
    }
}